import { render, staticRenderFns } from "./POSInvoiceSidebar.vue?vue&type=template&id=3cb4b17c&scoped=true&"
import script from "./POSInvoiceSidebar.vue?vue&type=script&lang=js&"
export * from "./POSInvoiceSidebar.vue?vue&type=script&lang=js&"
import style0 from "./POSInvoiceSidebar.vue?vue&type=style&index=0&id=3cb4b17c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb4b17c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VItem } from 'vuetify/lib/components/VItemGroup';
import { VItemGroup } from 'vuetify/lib/components/VItemGroup';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VAutocomplete,VAvatar,VBtn,VCard,VDivider,VIcon,VItem,VItemGroup,VSwitch})
